import { render } from "./contenteditable.vue?vue&type=template&id=1e6c36fa"
import script from "./contenteditable.vue?vue&type=script&lang=js"
export * from "./contenteditable.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/contenteditable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1e6c36fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1e6c36fa', __exports__)) {
    api.reload('1e6c36fa', __exports__)
  }
  
  module.hot.accept("./contenteditable.vue?vue&type=template&id=1e6c36fa", () => {
    api.rerender('1e6c36fa', render)
  })

}


export default __exports__